import React, { useState, useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import API from "../../actions";
import { Button, Typography } from "@material-ui/core";

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default
        },
        cursor: "pointer"
    }
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: "100%"
    }
});

export default props => {
    const classes = useStyles();
    const [index, setIndex] = useState("");
    const [courses, setCourses] = useState("");

    useEffect(() => {
        (async () => {
            const c = await API.clientGetEventsFromTherapist(props.therapistId);
            const dates = await API.clientGetEventDatesFromTherapist(props.therapistId);
            const cMap = {};
            c.forEach(course => {
                cMap[course.id] = course;
                cMap[course.id].dates = [];
            });
            dates.forEach(date => {
                if (Number(date.from) > Date.now()) cMap[date.eventId].dates.push(date);
            });
            setCourses(c.map(course => cMap[course.id]));
        })();
    }, [props.therapistId]);

    if (!courses) return <></>;
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell>Kursus</StyledTableCell>
                        <StyledTableCell align="right">Max antal deltagere</StyledTableCell>
                        <StyledTableCell align="right">Min antal deltagere</StyledTableCell>
                        <StyledTableCell align="right">Antal Datoer</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {courses.map((row, i) => {
                        if (row.dates.length === 0) return <></>;
                        return (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell align="left" style={{ width: "18%", verticalAlign: "top" }}>
                                    <Button
                                        onClick={() => {
                                            if (i === index) setIndex("");
                                            else setIndex(i);
                                        }}>
                                        Vis beskrivelse
                                    </Button>
                                </StyledTableCell>
                                <StyledTableCell
                                    scope="row"
                                    style={{ width: "40%", fontWeight: "bold" }}
                                    onClick={() => props.onClick(row)}>
                                    {row.title}
                                    {index === i && (
                                        <Typography
                                            className={classes.desc}
                                            dangerouslySetInnerHTML={{ __html: row.description }}></Typography>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    onClick={() => props.onClick(row)}
                                    style={{ width: "15%", verticalAlign: "top" }}>
                                    {row.limit}
                                </StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    onClick={() => props.onClick(row)}
                                    style={{ width: "15%", verticalAlign: "top" }}>
                                    {row.min}
                                </StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    onClick={() => props.onClick(row)}
                                    style={{ width: "12%", verticalAlign: "top" }}>
                                    {row.dates.length || 0}
                                </StyledTableCell>
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
